import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

import { environment } from 'environments/environment';

import { repeaterAnimation } from 'app/main/forms/form-repeater/form-repeater.animation';

import { AuthenticationService } from 'app/auth/service';
import { PeriodService } from 'app/Service/period/period.service';
import { OrderService } from 'app/Service/order/order.service';
import { BikeService } from 'app/Service/bike/bike.service';
import { AccessoryService } from 'app/Service/accessory/accessory.service';
import { ParameterService } from 'app/Service/parameter/parameter.service';
import { DiscountService } from 'app/Service/discount/discount.service';
import { TariffService } from 'app/Service/tariff/tariff.service';
import { ParticipantService } from 'app/Service/participant/participant.service';
import { OrderParticipantBikeService } from 'app/Service/order-participant-bike/order-participant-bike.service';
import { CoreConfigService } from '@core/services/config.service';
import { AgencyService } from 'app/Service/agency/agency.service';
import { AlertService } from 'app/Service/alert/alert.service';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';

@Component({
  selector: 'app-add-order',
  templateUrl: './add-order.component.html',
  styleUrls: ['./add-order.component.scss'],
  animations: [repeaterAnimation],
  encapsulation: ViewEncapsulation.None
})
export class AddOrderComponent implements OnInit {

  currentUser = Object.freeze(this.authenticationService.currentUserValue);
  apiUrl = environment.apiUrl

  public min_start = this.datepipe.transform(new Date, 'yyyy-MM-dd HH:mm')
  public min_end = ''
  public max_end = ''
  disableEnd = false
  loadedData = false

  public responsibleIndex = 0
  public responsible = null
  public agencies
  public periods
  public categoriesTariff
  public oldParticipants
  public bikes
  public checkedCircuit = 18
  public accessories
  public discounts
  public promoDiscounts
  public groupDiscounts

  public chosenBikes = []
  public chosenBikesCategories
  public bikesToOrder

  public totalPrice: number = 0
  public groupPrice = 0
  public discountedPrice = 0

  public cuationVelo
  public cautionAccessoire

  participantsFormHolder = [this._formBuilder.group({
    participantId: new FormControl(''),
    participantFirstName: new FormControl(''), participantLastName: new FormControl(''),
    participantCin: new FormControl(''), participantPhone: new FormControl(''),
    participantEmail: new FormControl('', [Validators.email]),
    participantBike: new FormControl(''), bikePrice: '',
    isResponsible: new FormControl(true)
  })];

  public orderForm: FormGroup;
  public orderSubmitted = false
  public loadingSubmitOrder = false

  public step = 1;

  public createdOrderId

  constructor(
    private authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _coreSidebarService: CoreSidebarService,
    private agencyService: AgencyService,
    private periodService: PeriodService,
    private tariffService: TariffService,
    private participantService: ParticipantService,
    private bikeService: BikeService,
    private accessoryService: AccessoryService,
    private discountService: DiscountService,
    private parameterService: ParameterService,
    private orderService: OrderService,
    private orderParticipantBike: OrderParticipantBikeService,
    private _formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private _router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService
  ) {
    if (!this._router.routerState.snapshot.url.includes('component')) {
      // Configure the layout
      this._coreConfigService.config = {
        layout: {
          navbar: {
            hidden: true
          },
          menu: {
            hidden: true
          },
          footer: {
            hidden: true
          },
          customizer: false,
          enableLocalStorage: false
        }
      };
    }
  }

  public a = 0; public b = 4;
  slide(where) {
    if (this.bikes.length >= this.b) {
      if (where === 'top') {
        this.a--
        this.b--
      } else {
        this.a++
        this.b++
      }
    }
  }

  // convenience getter for easy access to order form fields
  get o() {
    return this.orderForm.controls;
  }

  createOrderParticipantBike() {
    for (let p = 0; p < this.participantsFormHolder.length; p++) {
      this.orderParticipantBike.create(this.createdOrderId['id'],
        this.participantsFormHolder[p].get('participantId').value,
        this.participantsFormHolder[p].get('participantBike').value['id'],
        this.participantsFormHolder[p]['bikePrice'])
        .subscribe({
          next: (data) => {
            if (p + 1 == this.participantsFormHolder.length) {
              this.loadingSubmitOrder = false
              if (this.currentUser && this.currentUser.role === 'agency') {
                this._router.navigate([`/component/agency/order`]);
              } else {
                this._router.navigate([`/success/${this.createdOrderId['token']}`]);
              }
            }
          },
          error: (e) => {
            this.loadingSubmitOrder = false
            console.error(e)
          }
        });
    }
  }
  submitOrder() {
    let price = Math.round(this.totalPrice)
    if (this.groupPrice != 0) {
      price = this.groupPrice
    }
    if (this.discountedPrice != 0) {
      price = this.discountedPrice
    }
    let discount = ''
    if (this.o.discount.value != null) {
      discount = this.o.discount.value.id
    }
    this.responsible = this.participantsFormHolder.find(item => item.get('isResponsible').value == true)
    let user = null; let agency = this.o.agency.value
    if (this.currentUser) {
      user = this.currentUser.id
      if (this.currentUser.role === 'agency') {
        agency = this.currentUser.id
      }
    }
    this.bikesToOrder = this.participantsFormHolder.filter(item => item.get('participantBike').value != '').map(item => item.get('participantBike').value['id'])
    this.orderService.create(user, agency, this.o.period.value.id, discount, this.responsible.get('participantId').value, this.participantsFormHolder[0].get('participantId').value, this.o.start.value, this.o.end.value, this.o.comment.value, price, this.o.agent_price.value, this.o.accessory.value, this.bikesToOrder, null, null, this.o.promoCode.value)
      .subscribe({
        next: (data) => {
          this.createdOrderId = data
          this.createOrderParticipantBike()
        },
        error: (e) => {
          this.loadingSubmitOrder = false
          console.error(e)
        }
      });
  }
  createParticipants(newOnes) {
    for (let p = 0; p < newOnes.length; p++) {
      this.participantService.create(newOnes[p].get('participantCin').value,
        newOnes[p].get('participantFirstName').value, newOnes[p].get('participantLastName').value,
        newOnes[p].get('participantPhone').value, newOnes[p].get('participantEmail').value)
        .subscribe({
          next: (participant_id) => {
            newOnes[p].get('participantId').setValue(participant_id)
            if (p + 1 == newOnes.length) {
              this.submitOrder()
            }
          },
          error: (e) => {
            this.loadingSubmitOrder = false
            console.error(e)
          }
        });
    }
  }

  submitParticipants() {
    if (this.checkParticipantsForm() == true) {
      this.alertService.errorAlert(
        'vous devez indiquer la cin, le prénom, le nom, le numéro de téléphone et un vélo de chaque participant',
        'veuillez entrer des données appropriées');
    } else {
      this.participantsFormHolder = this.participantsFormHolder.filter(f => f.get('participantCin').value != '')
      let participantsCin = this.participantsFormHolder.map(item => item.get('participantCin').value)
      if (participantsCin.some((val, i) => participantsCin.indexOf(val) !== i)) {
        this.alertService.errorAlert('Vous avez des participants en double', 'Veuillez vérifier');
      } else {
        this.loadingSubmitOrder = true
        let newOnes = this.participantsFormHolder.filter(f => f.get('participantId').value === '')
        if (newOnes.length != 0) {
          this.createParticipants(newOnes)
        } else {
          this.submitOrder()
        }
      }
    }
  }

  clearDiscount() {
    let finalPrice = this.totalPrice
    if (this.groupPrice != 0) {
      finalPrice = this.groupPrice
    }
    this.discountedPrice = 0
    this.orderForm.get("agent_price").setValue(finalPrice.toFixed(2));
  }
  handleDiscount(e) {
    if (e && e.percentage != null) {
      let finalPrice = this.totalPrice
      if (this.groupPrice != 0) {
        finalPrice = this.groupPrice
      }
      this.discountedPrice = finalPrice - ((e.percentage / 100) * finalPrice)
      this.orderForm.get("agent_price").setValue(this.discountedPrice.toFixed(2));
    }
  }

  handleAgencyChoice() {
    if (this.orderForm.get('period').valid && this.orderForm.get('start').valid && this.orderForm.get('end').valid) {
      this.step = 1
      this.participantsFormHolder.forEach(element => {
        element.get('participantBike').reset()
      });
      this.handleParticipantBikes()
      this.next()
    }
  }

  getCategoriesTariff() {
    this.tariffService.getTariffsByPeriod(this.o.period.value.id, this.o.start.value, this.o.end.value)
      .subscribe({
        next: (data) => {
          this.categoriesTariff = data
          this.getBikes()
        },
        error: (e) => console.error(e)
      });
  }

  next() {
    switch (this.step) {
      case 1: {
        this.orderSubmitted = true
        if (!this.currentUser || this.currentUser.role != 'agency') {
          if (this.orderForm.get('agency').valid && this.orderForm.get('period').valid && this.orderForm.get('start').valid && this.orderForm.get('end').valid) {
            this.getCategoriesTariff()
            this.step++
          } else {
            return
          }
        } else {
          if (this.orderForm.get('period').valid && this.orderForm.get('start').valid && this.orderForm.get('end').valid) {
            this.getCategoriesTariff()
            this.step++
          } else {
            return
          }
        }
        this.getDiscounts()
        this.totalPrice = 0
        this.participantsFormHolder = [this._formBuilder.group({
          participantId: new FormControl(''),
          participantFirstName: new FormControl(''), participantLastName: new FormControl(''),
          participantCin: new FormControl(''), participantPhone: new FormControl(''),
          participantEmail: new FormControl(''),
          participantBike: new FormControl(''), bikePrice: '',
          isResponsible: new FormControl(true)
        })];
        break;
      }
      case 2: {
        if (this.checkParticipantsForm() == true) {
          this.alertService.errorAlert(
            'vous devez indiquer la cin, le prénom, le nom, le numéro de téléphone et un vélo de chaque participant',
            'veuillez entrer des données appropriées');
        } else {
          this.step++
        }
        break;
      }
      case 3: {
        this.getAccessories()
        this.bikesToOrder = this.participantsFormHolder.filter(item => item.get('participantBike').value != '').map(item => item.get('participantBike').value['id'])
        this.getBikeDepositParameter()
        this.getAccessoryDepositParameter()
        this.step++
        break;
      }
    }
  }

  previous() {
    this.orderSubmitted = false
    this.orderForm.reset()
    this.step--
  }

  getEnd() {
    if (this.o.start.value) {
      this.disableEnd = false
      this.orderForm.get('end').reset()
      this.min_end = ''
      this.max_end = ''
      if (this.o.period.value.value === '*') {
        let end = new Date(this.o.start.value)
        end.setDate(end.getDate() + 1)
        this.min_start = this.datepipe.transform(new Date, 'yyyy-MM-dd HH:mm')
        this.min_end = this.datepipe.transform(end, 'yyyy-MM-dd HH:mm')
        this.max_end = ''
      } else {
        let end = new Date(this.o.start.value)
        if (this.o.period.value.value === '1' && this.o.period.value.type === 'day') {
          end.setHours(22, 0, 0)
          this.orderForm.get('end').setValue(this.datepipe.transform(end, 'yyyy-MM-dd HH:mm'))
          this.min_end = this.o.start.value
          this.max_end = this.o.start.value
        }
        else {
          end.setHours(Number(end.getHours()) + Number(this.o.period.value.value))
          this.orderForm.get('end').setValue(this.datepipe.transform(end, 'yyyy-MM-dd HH:mm'))
          this.disableEnd = true
        }
      }
    }
  }

  handleChosenPeriod() {
    if (this.orderForm.get('start').touched) {
      this.getEnd()
    }
  }

  // get needed data
  getAccessoryDepositParameter() {
    this.parameterService.getSpecificParameter('accessory_deposit')
      .subscribe({
        next: (data) => {
          this.cautionAccessoire = data[0]
        },
        error: (e) => console.error(e)
      });
  }
  getBikeDepositParameter() {
    this.parameterService.getSpecificParameter('bike_deposit')
      .subscribe({
        next: (data) => {
          this.cuationVelo = data[0];
        },
        error: (e) => console.error(e)
      });
  }
  getDiscounts() {
    this.discountService.getAll()
      .subscribe({
        next: (data) => {
          this.discounts = data
          this.promoDiscounts = this.discounts.filter((obj) => { return obj.statut == true && obj.type === 'promotion' })
          this.groupDiscounts = this.discounts.filter((obj) => { return obj.statut == true && obj.type === 'groupe' })
        },
        error: (e) => console.error(e)
      });
  }
  getAccessories(): void {
    if (this.currentUser && this.currentUser.role === 'agency') {
      this.accessoryService.getFreeAccessories(this.currentUser.id, this.o.start.value, this.o.end.value)
        .subscribe({
          next: (data) => {
            this.accessories = data;
          },
          error: (e) => console.error(e)
        });
    }
  }
  getBikes(): void {
    this.loadedData = false
    let user = null
    if (this.currentUser && this.currentUser.role === 'agency') {
      user = this.currentUser.id
    } else {
      user = this.o.agency.value
    }
    this.bikeService.getFreeBikes(user, this.o.start.value, this.o.end.value)
      .subscribe({
        next: (data) => {
          this.bikes = data;
          if (this.categoriesTariff && this.categoriesTariff.length > 0) {
            this.bikes.forEach(element => {
              let category = this.categoriesTariff.find(obj => obj.category === element['category_title'])
              element['price'] = category.price
            });
          }
          this.loadedData = true
          this.toggleSidebar('bike-sidebar')
        },
        error: (e) => console.error(e)
      });
  }
  getOldParticipants(): void {
    this.participantService.getAll()
      .subscribe({
        next: (data) => {
          this.oldParticipants = data;
        },
        error: (e) => console.error(e)
      });
  }
  retrievePeriods() {
    this.periodService.getAll()
      .subscribe({
        next: (data) => {
          this.periods = data;
        },
        error: (e) => console.error(e)
      });
  }
  retrieveAgencies() {
    this.agencyService.getAvailableAgencies()
      .subscribe({
        next: (data) => {
          this.agencies = data;
        },
        error: (e) => console.error(e)
      });
  }

  ngOnInit(): void {
    this.retrieveAgencies()
    this.retrievePeriods()
    if (this.currentUser && this.currentUser.role === 'agency') {
      this.getOldParticipants()
    }

    //order
    this.orderForm = this._formBuilder.group({
      agency: [''],
      period: ['', [Validators.required]],
      start: ['', [Validators.required]],
      end: ['', [Validators.required]],
      comment: [''],
      accessory: [''],
      responsible: ['', [Validators.required]],
      agent_price: [''],
      discount: [''],
      promoCode: [''],
    });
  }

  //participants 
  addParticipant() {
    let newForm = {
      participantId: new FormControl(''),
      participantFirstName: new FormControl(''), participantLastName: new FormControl(''),
      participantCin: new FormControl(''), participantPhone: new FormControl(''),
      participantEmail: new FormControl(''),
      participantBike: new FormControl(''), bikePrice: '',
      isResponsible: new FormControl(false)
    }
    this.participantsFormHolder.push(this._formBuilder.group(newForm))
  }
  deleteParticipant(toDelete) {
    if (toDelete.get('isResponsible').value == true) {
      this.responsibleIndex = 0
      this.participantsFormHolder[0].get('isResponsible').setValue(true)
    }
    let aux: any[] = [];
    for (let form of this.participantsFormHolder) {
      if (toDelete !== form) {
        aux.push(form);
      }
    }
    this.participantsFormHolder = aux;
    this.handleParticipantBikes()
  }

  handleParticipantBike(event, index) {
    this.participantsFormHolder[index]['bikePrice'] = event.price
    this.handleParticipantBikes()
  }
  handleParticipantBikes() {
    this.chosenBikes = this.participantsFormHolder.filter(item => item.get('participantBike').value != null && item.get('participantBike').value != '').map(item => item.get('participantBike').value)
    this.totalPrice = 0; this.groupPrice = 0
    this.chosenBikes.forEach(element => {
      this.totalPrice += parseFloat(element.price)
    });
    let groupDiscount = this.groupDiscounts.find(item => parseInt(item.minimum) <= this.chosenBikes.length && parseInt(item.maximum) >= this.chosenBikes.length)
    if (groupDiscount) {
      this.groupPrice = this.totalPrice - ((groupDiscount.percentage / 100) * this.totalPrice)
    }
    this.orderForm.get("agent_price").setValue(this.totalPrice.toFixed(2));
  }
  setIsResonsible(index) {
    this.responsibleIndex = index
    this.participantsFormHolder.forEach(function (item) {
      item.get('isResponsible').setValue(false)
    });
    this.participantsFormHolder[index].get('isResponsible').setValue(true)
  }
  checkParticipantsForm() {
    let response = 0
    if (this.categoriesTariff && this.categoriesTariff.length > 0 && this.totalPrice != 0) {
      this.participantsFormHolder.forEach(element => {
        if (element.get('participantId').value != '') {
          if (element.get('participantBike').value != '' && element.get('participantBike').value != null) {
            response++
          }
        } else {
          if (element.get('participantFirstName').value != '' && element.get('participantFirstName').value != null
            && element.get('participantLastName').value != '' && element.get('participantLastName').value != null
            && element.get('participantCin').value != '' && element.get('participantCin').value != null
            && element.get('participantPhone').value != '' && element.get('participantPhone').value != null && element.get('participantPhone').valid
            && element.get('participantBike').value != '' && element.get('participantBike').value != null && element.get('participantEmail').valid) {
            response++
          }
        }
      });
      if (response == this.participantsFormHolder.length) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  getParticipant(event, formIndex, attribut) {
    let currentParticipant = this.oldParticipants.find((obj) => {
      return obj[attribut] == event.target.value
    })
    if (currentParticipant) {
      this.participantsFormHolder[formIndex].patchValue({
        participantId: currentParticipant.participantId,
        participantFirstName: currentParticipant.participantFirstName,
        participantLastName: currentParticipant.participantLastName,
        participantCin: currentParticipant.participantCin,
        participantPhone: currentParticipant.participantPhone,
        participantEmail: currentParticipant.participantEmail,
      });
      this.participantsFormHolder[formIndex].get('participantFirstName').disable()
      this.participantsFormHolder[formIndex].get('participantLastName').disable()
      this.participantsFormHolder[formIndex].get('participantPhone').disable()
      this.participantsFormHolder[formIndex].get('participantEmail').disable()
    } else {
      this.participantsFormHolder[formIndex].get('participantFirstName').reset({ value: '', disabled: false });
      this.participantsFormHolder[formIndex].get('participantLastName').reset({ value: '', disabled: false });
      this.participantsFormHolder[formIndex].get('participantPhone').reset({ value: '', disabled: false });
      this.participantsFormHolder[formIndex].get('participantEmail').reset({ value: '', disabled: false });
    }
  }

  disableDate() {
    return false;
  }

  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }
}
